<template>
  <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'with-hover': withHover }">
    <path
      d="M2.25 13.095v2.28c0 .21.165.375.375.375h2.28a.352.352 0 00.263-.113l8.19-8.182-2.813-2.813-8.183 8.183a.368.368 0 00-.112.27zM15.533 5.28a.747.747 0 000-1.058l-1.755-1.755a.747.747 0 00-1.058 0L11.347 3.84l2.813 2.812 1.373-1.372z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    withHover: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg {
  path {
    fill: var(--r-grey-3);
  }

  &.with-hover:hover {
    path {
      fill: var(--r-secondary-1);
    }
  }
}
</style>
